import React from "react";
import allPaths from "../../Config/paths"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const BackgroundImage = ({screenName,classForBg,selectedLanguage}) => {
    const history = useHistory()
    return (
        <div>
            <div className="fifth-des-bg-header">
                <div className="fifth-des-bg-header-inner">
                    <h2>
                        {screenName}
                    </h2>
                    <p>
                        <span onClick={()=>history?.push(allPaths?.FIFHTHOME)}>{selectedLanguage?.txt_Home} </span>/ {screenName}
                    </p>
                </div>
            </div>
            <div className={`${classForBg} fifth-des-bg-img-section`}></div>
        </div>
    )
}
export default BackgroundImage